(function (Drupal, $) {
  Drupal.behaviors.newsroomViewForm = {
    attach: function attach(context) {
      $('#newsroom-styled-form', context).each(function () {
        // Expand filters
        $('.newsroom__styled-form__filters.plus').on('click', function(){
          $(this).parents('.block-views').first().addClass('newsroom__filter__open');
          $(this).attr('aria-expanded', 'true');
          $('.newsroom__styled-form__filters.minus').attr('aria-expanded', 'true');
        });
        $('.newsroom__styled-form__filters.minus').on('click', function(){
          $(this).parents('.block-views').first().removeClass('newsroom__filter__open');
          $(this).attr('aria-expanded', 'false');
          $('.newsroom__styled-form__filters.plus').attr('aria-expanded', 'false');
        });
        // Type Filter
        $('.js--newsroom__type__option').on('click', function(){
          if($(this).hasClass('clicked')){
            $('[data-drupal-selector="edit-field-article-type-target-id"]').val('All');
            $('.form-actions input').click();
          } else {
            $('[data-drupal-selector="edit-field-article-type-target-id"]').val($(this).data('value'));
            $('.form-actions input').click();
          }
        });
        // Type Filter: ADA keyboard submit
        $('.newsroom__styled-form__filters__additional__type__options > input').on('keypress', function(event){
          var keycode = (event.keyCode ? event.keyCode : event.which);
          if(keycode === 13) {
            if ($(this).is(':checked')) {
              var label = $("label[for='" + $(this).attr('id') + "']");
              $('[data-drupal-selector="edit-field-article-type-target-id"]').val(label.data('value'));
              $('.form-actions input').click();
            }
          }
        });
        // Topic Filter
        $('.js--newsroom__topics__option').on('click', function(){
          if($(this).hasClass('clicked')){
            $('[data-drupal-selector="edit-field-news-article-topics-target-id"]').val('All');
            $('.form-actions input').click();
          } else {
            $('[data-drupal-selector="edit-field-news-article-topics-target-id"]').val($(this).data('value'));
            $('.form-actions input').click();
          }
        });
        // Topic Filter: ADA keyboard submit
        $('.newsroom__styled-form__filters__additional__topic input').on('keypress', function(event){
          var keycode = (event.keyCode ? event.keyCode : event.which);
          if(keycode === 13) {
            if ($(this).is(':checked')) {
              var label = $("label[for='" + $(this).attr('id') + "']");
              $('[data-drupal-selector="edit-field-news-article-topics-target-id"]').val(label.data('value'));
              $('.form-actions input').click();
            }
          }
        });
        // Key word title search filter
        $('.newsroom__styled-form__search__icon').on('click', function(){
          $('[data-drupal-selector="edit-title"]').val($('#pretty-search').val());
          $('.form-actions input').click();
        });
        $('#pretty-search').keypress(function(event){
          var keycode = (event.keyCode ? event.keyCode : event.which);
          if(keycode === 13){
            $('[data-drupal-selector="edit-title"]').val($('#pretty-search').val());
            $('.form-actions input').click();
          }
        });
        // Sort by mouse click controls
        $('.newsroom__styled-form__sort__expand').on('click', function(){
          $('.newsroom__styled-form__sort__options').toggleClass('closed');
        });
        $('.newsroom__styled-form__sort__options #most-recent').on('click', function(){
          $('[data-drupal-selector="edit-sort-by"]').val('created');
          $('[data-drupal-selector="edit-sort-order"]').val('DESC');
          $('.form-actions input').click();
        });
        $('.newsroom__styled-form__sort__options #oldest-first').on('click', function(){
          $('[data-drupal-selector="edit-sort-by"]').val('created');
          $('[data-drupal-selector="edit-sort-order"]').val('ASC');
          $('.form-actions input').click();
        });
        $('.newsroom__styled-form__sort__options #a-z').on('click', function(){
          $('[data-drupal-selector="edit-sort-by"]').val('title');
          $('[data-drupal-selector="edit-sort-order"]').val('ASC');
          $('.form-actions input').click();
        });



        // Handle keyboard for the sort by
        var container;
        var trigger;
        var selectedText;
        var optionsList;
        var options;
        var isExpanded = false;

        container = document.querySelector('.custom-select');
        trigger = document.querySelector('.newsroom__styled-form__sort__expand');
        selectedText = document.getElementById('selected__sort_by');
        optionsList = document.querySelector('.custom-select .newsroom__styled-form__sort__options');
        options = document.querySelectorAll('.custom-select .newsroom__styled-form__sort__options li');

        // Handle keyboard and mouse interactions on the trigger bar
        trigger.addEventListener('keydown', handleTriggerKeypresses);
        trigger.addEventListener('click', handleTriggerClick);

        // Select options when they are clicked
        options.forEach(function(option) {
          option.addEventListener('click', function(e) {
            unselectAllOptions();
            selectOption(e.target);
            collapseOptions();
            trigger.focus();
          });
        });

        // Collapse the dropdown when the user clicks off
        document.addEventListener('click', handleBodyClick);


      /**
       Event handlers
       */
      function handleTriggerKeypresses(e) {
        switch(e.key) {
          case 'ArrowUp':
            e.preventDefault();

            if(isExpanded) {
              selectPreviousOption();
            } else {
              expandOptions();
            }
            break;

          case 'ArrowDown':
            e.preventDefault();
            if(isExpanded) {
              selectNextOption();
            } else {
              expandOptions();
              selectFirstOption();
            }
            break;

          case 'Home':
            if(isExpanded) {
              selectFirstOption();
            }
            break;

          case 'End':
            if(isExpanded) {
              selectLastOption();
            }
            break;

          case 'Tab':
            collapseOptions();
            break;

          case 'Escape':
          case 'Enter':
            if(isExpanded) {
              var selectedEl = document.getElementById(trigger.getAttribute('aria-activedescendant'));
              // Trigger the sort
              $(selectedEl).click();
              collapseOptions();
            }
            break;
        }
      }

      function handleBodyClick(e) {
        if(!container.contains(e.target) && isExpanded) {
          collapseOptions();
        }
      }

      function handleTriggerClick() {
        if(isExpanded) {
          collapseOptions();
          trigger.focus();
        } else {
          expandOptions();
        }
      }


      /**
       Show/hide option list
       */
      function collapseOptions() {
        trigger.setAttribute('aria-expanded', false);
        optionsList.classList.remove('is-visible');
        isExpanded = false;
      }

      function expandOptions() {
        trigger.setAttribute('aria-expanded', true);
        optionsList.classList.add('is-visible');
        isExpanded = true;
      }


      /**
       Option selection
       */
      function selectFirstOption() {
        var firstOption = options[0];
        selectOption(firstOption);
      }

      function selectLastOption() {
        var lastOption = options[options.length-1];
        selectOption(lastOption);
      }

      function selectNextOption() {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));

        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);

          if(currentOptionIndex + 1 < options.length) {
            var nextOption = options[currentOptionIndex + 1];
            selectOption(nextOption);
          }
        }
      }

      function selectPreviousOption() {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));

        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);

          if(currentOptionIndex - 1 >= 0) {
            var previousOption = options[currentOptionIndex - 1];
            selectOption(previousOption);
          }
        }
      }

      function selectOption(option) {
        unselectAllOptions();
        option.setAttribute('aria-selected', true);
        trigger.setAttribute('aria-activedescendant', option.getAttribute('id'));
        selectedText.innerHTML = option.innerHTML;
      }

      function unselectAllOptions() {
        options.forEach(function(option) {
          option.removeAttribute('aria-selected');
        });
      }
      });
    }
  }
})(Drupal, jQuery);
